import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["preview", "hexInput", "colorInput"]

    connect() {
        // reflect preview when hex changes
        this.hexInputTarget.addEventListener('change', (e) => {
            this.previewTarget.style.backgroundColor = e.target.value
        })

        // keep picker in sync with current node
        this._onInspect = (e) => {
            const hex = e.detail?.color || "#000000"
            this.previewTarget.style.backgroundColor = hex
            this.hexInputTarget.value = hex
            // don't set colorInput.value (native input) unless hex is 7-char #rrggbb
            if (/^#[0-9a-f]{6}$/i.test(hex)) this.colorInputTarget.value = hex
        }
        document.addEventListener("ie:inspect", this._onInspect)
    }

    disconnect() {
        document.removeEventListener("ie:inspect", this._onInspect)
    }

    selectColor(event) {
        event.preventDefault()
        event.stopPropagation()

        const el  = event.currentTarget.closest("[data-color]") || event.currentTarget
        let hex   = el.getAttribute("data-color") || el.dataset?.color || ""

        if (!hex) {
            const rgb = getComputedStyle(el).backgroundColor
            hex = this._rgbToHex(rgb) || "#000000"
        }

        // Update UI
        this.previewTarget.style.backgroundColor = hex
        this.hexInputTarget.value = hex

        // Keep the native <input type="color"> in sync AND fire live updates
        if (/^#[0-9a-f]{6}$/i.test(hex)) {
            this.colorInputTarget.value = hex
            // Fire 'input' so any live-updaters react immediately
            this.colorInputTarget.dispatchEvent(new Event("input", { bubbles: true }))
        }

        // Also notify our Konva bridge (in case it listens for this custom event)
        document.dispatchEvent(new CustomEvent("ie:setColor", { detail: { hex } }))
    }

    handleColorInputChange(event) {
        const color = event.target.value
        this.previewTarget.style.backgroundColor = color
        this.hexInputTarget.value = color

        document.dispatchEvent(new CustomEvent("ie:setColor", { detail: { hex: color } }))
    }
}